import toFinite from 'lodash/toFinite'

/* eslint-disable no-multi-spaces */
export const parseNumberFunction = (options) => (number) => parseNumber(number, options)

export const parseNumber = (number, options = {}) => {
  if (typeof number === 'string') {
    number = number.split(' ').join('')
  }
  const parsedNumber = parseFloat(number)

  if (options.zero) {
    return toFinite(parsedNumber)
  }
  return parsedNumber
}

export const numberToHuman = (number) => {
  let humanReadableNumber = 0

  if (number >= 1000000000) {
    humanReadableNumber = (number / 1000000000).toFixed(1) + ' Billion'
  } else if (number >= 1000000) {
    humanReadableNumber = (number / 1000000).toFixed(1) + ' Million'
  } else if (number >= 1000) {
    humanReadableNumber = (number / 1000).toFixed(1) + ' Thousand'
  } else if (number >= 100) {
    humanReadableNumber = (number / 100).toFixed(1) + ' Hundred'
  } else {
    humanReadableNumber = number
  }

  return humanReadableNumber
}

export const humanizedPercent = (value, opts) => {
  value = value || 0 // prevent parse error on null and undefiend values

  const decimalPlaces = opts && opts.decimalPlaces ? parseInt(opts.decimalPlaces) : 0
  const expandedVal   = (parseFloat(value) * 100).toFixed(decimalPlaces)

  return `${expandedVal} %`
}
